import { greeting } from "@tc/ui";
/**
 * THE COMPANY'S WELCOME, straight after signing in (Jamie 21/10/26: "a nice Tankerford one and a nice Nozl one … it
 * looks tacky" when the sign-in screen flashed on the way into the app). The Nozl splash opens the app; this one
 * plays the moment a PIN, Face ID or password is accepted: the company's logo on the black with its own colour
 * sweeping under it and "Good evening, Jamie". It's put on the page itself (not inside React), so it stays up while
 * the sign-in screen gives way to the app underneath, and goes once the app has drawn (welcomeDone), never before
 * 1.9 seconds and never after 7. Not shown to people who've asked for less motion.
 */
const MIN_MS = 1900;
const MAX_MS = 7000;
let shown = null;
export function showWelcome(company, first) {
    if (shown || typeof document === "undefined")
        return;
    try {
        if (matchMedia("(prefers-reduced-motion: reduce)").matches)
            return;
    }
    catch { /* old browser */ }
    const b = company?.branding ?? {};
    const el = document.createElement("div");
    el.id = "tc-welcome";
    el.setAttribute("aria-hidden", "true");
    if (b.brand)
        el.style.setProperty("--wb", b.brand);
    const mark = document.createElement("div");
    mark.className = `mark ${b.logoUrl ? `${b.logoShape ?? "square"} tone-${b.logoTone ?? "light"}` : "initials"}`;
    if (b.logoUrl) {
        const img = document.createElement("img");
        img.src = b.logoUrl;
        img.alt = "";
        mark.appendChild(img);
    }
    else {
        mark.textContent = (company?.name ?? "").split(/\s+/).map((w) => w[0] ?? "").join("").slice(0, 2).toUpperCase();
    }
    const hi = document.createElement("p");
    hi.className = "hi";
    hi.textContent = `${greeting()}${first ? `, ${first}` : ""}`;
    // The swoosh in the company's colour: one whole tapered curve, drawn in (the same shape as the Nozl splash).
    const sweep = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    sweep.setAttribute("class", "sweep");
    sweep.setAttribute("viewBox", "0 0 1000 180");
    sweep.setAttribute("preserveAspectRatio", "none");
    for (const [d, cls] of [["M30 160C330 156 660 108 975 14C690 128 340 178 30 160Z", ""], ["M150 174C430 172 720 138 955 70C730 152 440 182 150 174Z", "t"]]) {
        const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
        path.setAttribute("d", d);
        if (cls)
            path.setAttribute("class", cls);
        sweep.appendChild(path);
    }
    el.append(mark, hi, sweep);
    document.body.appendChild(el);
    shown = { el, at: performance.now() };
    window.setTimeout(() => welcomeDone(true), MAX_MS);
}
/** The app has drawn (or signing in didn't go through): let the welcome go, after its minimum. */
export function welcomeDone(now = false) {
    const s = shown;
    if (!s)
        return;
    shown = null;
    const wait = now ? 0 : Math.max(0, MIN_MS - (performance.now() - s.at));
    window.setTimeout(() => {
        s.el.classList.add("out");
        window.setTimeout(() => s.el.remove(), 520);
    }, wait);
}
